import { render, staticRenderFns } from "./StockViewReleaseProductStepCartProducts.vue?vue&type=template&id=04488d0d"
import script from "./StockViewReleaseProductStepCartProducts.vue?vue&type=script&lang=js"
export * from "./StockViewReleaseProductStepCartProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports